export default __webpack_public_path__ + "static/media/benjamin.65167517.png";